import React from 'react'
import { Container } from 'reactstrap'
import HolidayComponent from '../../../Components/paper/holiday'
function HolidayPage() {
    return (
        <div className='page-body'>
            <Container fluid>
                <HolidayComponent />
            </Container>
        </div>
    )
}

export default HolidayPage